import React from 'react';
import NFTPriceSymbol from '../../../components/NFTPriceSymbol';
import { SaleTokenList } from '../../../data/SaleTokenList';
import Counter from '../../../newComponents/Counter';
/*@ts-ignore */
import FlipCountdown from '@rumess/react-flip-countdown';
import { useDarkModeManager } from '../../../../../state/user/hooks';
import NFTButton from '../../../newComponents/NFTButton';
import Scrollbar from '../../../components/Scrollbar';
import useSale from '../../../../../hooks/useSale';
import { ISaleItem } from '../../../data/SaleList';
import { useAddPopup } from '../../../../../state/application/hooks';
import { useActiveWeb3React } from '../../../../../hooks';
import { SalePageCards, SalePageContainer, SalePageContent, SalePageCounter, SalePageDescription, SalePageDetail, SalePageHeader, SalePageMint } from './styled';
import { Helmet } from 'react-helmet';
import pageBG from "../../../../../assets/images/foo.png";
import CardCarousel from '../../../newComponents/CardCarousel';
import NFTCard from '../../../newComponents/NFTCard';

interface IRoboClashSalePageProps {
    saleData: ISaleItem;
}


const RoboClashSalePage = (props: IRoboClashSalePageProps) => {
    const { account, active } = useActiveWeb3React();
    const { setMintAmount, calculatingPriceText, calculatingPrice, hasSaleStarted, mintNFT } = useSale(props.saleData.name);
    const startTime = null;
    const [darkMode] = useDarkModeManager()
    const [mintEnable, setMintEnable] = React.useState<boolean>(true);

    const addPopup = useAddPopup();

    const onChange = (count: number) => {
        setMintAmount(count);
    }

    const ClaimNFT = () => {
        if (mintNFT && mintEnable && calculatingPrice > 0 && hasSaleStarted) {
            setMintEnable(false)
            mintNFT().then(e => {
                setMintEnable(true)
            }).catch(e => {
                setMintEnable(true)
                addPopup({
                    txn: { hash: "", success: false, summary: "NFT Mint Failed", linkRemove: true }
                });
            })
        }
    }

    return (
        <Scrollbar>
            <Helmet>
                <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Holtwood+One+SC" media="all"></link>
                <title>{props.saleData.title} on YetiSwap NFT Marketplace</title>
            </Helmet>
            <SalePageContainer backgroundImg={pageBG}>
                <SalePageCounter>
                    <FlipCountdown
                        hideYear
                        hideMonth
                        endAtZero
                        size={"small"}
                        titlePosition={"bottom"}
                        theme={'light'} // Options (Default: dark): dark, light.
                        endAt={startTime ? new Date(startTime).toISOString() : props.saleData.saleDate} // Date/Time
                    />
                </SalePageCounter>
                <SalePageHeader fontFamily={"'Holtwood One SC'"}>
                    {/* <h1>Welcome to <br/> RoboClash</h1>
                    <h2>CRAFT - EQUIP - FIGHT</h2> */}
                </SalePageHeader>
                <SalePageContent>
                    <SalePageCards>
                        <CardCarousel noCardAnimation autoPlay={true} autoPlaySpeed={2000} spread={"wide"}>
                            <img src={"https://roboclash.io/images/COMING-SOON-kopya-2-3.svg"} height={500} alt={"Junkyard Scavengers"} />
                            <img src={"https://roboclash.io/images/COMING-SOON-kopya.svg"} height={500} alt={"Crafting"} />
                            <img src={"https://roboclash.io/images/robo-web-pvp-gorsel.svg"} height={500} alt={"PVP"} />
                        </CardCarousel>
                    </SalePageCards>
                    <SalePageDetail>
                        <SalePageMint>
                            <Counter onChange={onChange} max={5} min={1} />
                            <div>
                                <NFTPriceSymbol symbol={<h1>{calculatingPriceText + " AVAX"}</h1> as any} image={SaleTokenList[1].image} />
                            </div>
                            <NFTButton solid style={{ flex: 'unset', width: '50%', fontSize: '1.5rem' }} onClick={ClaimNFT} disabled={!mintEnable || !account || !active}>{account && active ? "Mint" : "Connect Your Account to Mint"}</NFTButton>
                        </SalePageMint>
                        <SalePageDescription fontFamily={"'Holtwood One SC'"} backgroundImg={"https://roboclash.io/images/cef_1.svg"}>
                            <span>
                                {"RoboClash is an NFT-based game with a Play-To-Earn structure where you can earn coins and in-game rewards by fighting in Daily Missions and PVP. Craft your items for more-rare NFTs or bring along your friends to earn even more rewards."}
                            </span>
                        </SalePageDescription>
                    </SalePageDetail>
                </SalePageContent>
            </SalePageContainer>
        </Scrollbar>
    )
}
export default RoboClashSalePage;